import React, { useEffect, useMemo, useRef, useState } from "react";
import NavbarLiora from "../../components/NavbarLiora/NavbarLiora";
import HeroSection from "../../components/HeroSection/HeroSection";
import { Col, Container, Row } from "react-bootstrap";
import CardQuiz from "../../components/CardQuiz/CardQuiz";
import QuizFilters from "../../components/QuizFilters/QuizFilters";
import "./Quiz.scss";
import SignUpBanner from "../../components/SignUpBanner/SignUpBanner";
import Footer from "../../components/Footer/Footer";
import { QuizCategoryId, QuizSubCategory } from "../../models/quizCategory";

const Quiz = () => {
  const [selectedCategory, setSelectedCategory] =
    useState<QuizCategoryId | null>(null);
  const [selectedSubCategory, setSelectedSubCategory] =
    useState<QuizSubCategory | null>(null);

  const [quizzes, setQuizzes] = useState<any[]>([]);
  const [isLoading, setIsLoading] = useState(true);
  const [errorMessage, setErrorMessage] = useState<string | null>(null);

  const quizSectionRef = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    fetch(process.env.REACT_APP_ENDPOINT_URL as string)
      .then((response) => response.json())
      .then((data) => {
        setQuizzes(data);
      })
      .catch((error) => {
        console.error("Error while fetching quizzes from API:", error);
        setErrorMessage(
          "Impossible de charger les quiz pour le moment. Veuillez réessayer plus tard."
        );
      })
      .finally(() => {
        setIsLoading(false);
      });
  }, []);

  const filtered = useMemo(() => {
    return quizzes.filter((quiz) => {
      if (selectedCategory && quiz.category !== selectedCategory) {
        return false;
      }

      if (selectedSubCategory && quiz.subcategory !== selectedSubCategory) {
        return false;
      }

      return true;
    });
  }, [quizzes, selectedCategory, selectedSubCategory]);

  const hasNoQuizForCategory = useMemo(
    () =>
      !isLoading &&
      !errorMessage &&
      selectedCategory !== null &&
      filtered.length === 0,
    [isLoading, errorMessage, selectedCategory, filtered.length]
  );

  useEffect(() => {
    if (!selectedCategory) return;

    quizSectionRef.current?.scrollIntoView({
      behavior: "smooth",
      block: "start",
    });
  }, [selectedCategory]);

  return (
    <div>
      <NavbarLiora />
      <HeroSection />
      <Container className="pt-3 pt-md-5" ref={quizSectionRef}>
        <Row>
          <Col lg={3} className="mb-4 mb-lg-0">
            <QuizFilters
              selectedCategory={selectedCategory}
              onSelectCategory={(category: QuizCategoryId | null) =>
                setSelectedCategory(category)
              }
              onSelectSubCategory={(subcategory: QuizSubCategory | null) =>
                setSelectedSubCategory(subcategory)
              }
              selectedSubCategory={selectedSubCategory}
            />
          </Col>
          <Col lg={9} id="quiz-container">
            {isLoading && (
              <Row className="g-4 d-flex quiz-list">
                {[...Array(6)].map((_e, index) => (
                  <Col
                    key={`quiz-mock-${index}`}
                    lg={4}
                    md={6}
                    sm={12}
                    className="quiz-item"
                  >
                    <CardQuiz mock />
                  </Col>
                ))}
              </Row>
            )}
            {errorMessage && <p className="text-danger">{errorMessage}</p>}
            {hasNoQuizForCategory && (
              <div className="">
                <h5 className="mb-2">Aucun quiz disponible</h5>
                <p className="text-muted">
                  Il n’existe actuellement aucun quiz pour cette catégorie.
                </p>
              </div>
            )}
            {!isLoading && !errorMessage && (
              <Row className="g-4 d-flex quiz-list">
                {filtered.map((quiz, index) => (
                  <Col
                    key={quiz.id ?? index}
                    lg={4}
                    md={6}
                    sm={12}
                    className="quiz-item"
                  >
                    <CardQuiz quiz={quiz} />
                  </Col>
                ))}
              </Row>
            )}
          </Col>
        </Row>
      </Container>
      <SignUpBanner />
      <Footer />
    </div>
  );
};

export default Quiz;
